import { Box, Grid2 } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomTypography from '@ui-components/Typography/CustomTypography';

// Icon
import ArrowUp from '@assets/images/arrows-up.svg';
import CheckIcon from '@assets/images/check.svg';
import { useFontSize } from '@qler-view/shared_lib/src/shared/lib/providers/FontSizeContext';

import CurrentDate from '../components/Date';
import CurrentTime from '../components/Time';
import CustomDivider from '@ui-components/Divider/CustomDivider';
import CustomListItemIcon from '@ui-components/List/CustomListItemIcon';
import CustomMenu from '@ui-components/Menu/CustomMenu';
import CustomMenuItem from '@ui-components/Menu/CustomMenuItem';
import CustomMenuList from '@ui-components/Menu/CustomMenuList';
import CustomAvatar from '@ui-components/Avatar/CustomAvatar.js';

import Logout from '@assets/images/logout.svg';
import User from '@assets/images/user.svg';
import Email from '@assets/images/email.svg';
import { useAuth } from '@auth/AuthProvider';
import { getUserFromStorage } from '../login/storageUtility';

const Appbar: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorUserEl, setAnchorUserEl] = useState<null | HTMLElement>(null);
  const { logout } = useAuth();
  const { fontSize, setFontSize } = useFontSize();

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorUserEl(null);
  };

  const handleUserMenuOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorUserEl(event.currentTarget);
  };

  const handleOpeartionUserLogout = () => {
    localStorage.clear();
    logout();
  };

  useEffect(() => {
    return () => {
      document.documentElement.style.zoom = '1';
    };
  }, []);

  const userName = localStorage.getItem('username')?.charAt(0).toUpperCase();
  const user = getUserFromStorage();

  return (
    <Box className="pb-16">
      <Grid2 container className="align-items-center">
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 7, xl: 7 }}>
          <CustomTypography
            id="page-title"
            variant="h4"
            className="text-align-left"
          >
            {/* <PageTitle /> */}
          </CustomTypography>
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 5, xl: 5 }}>
          <Box className="flex float-right align-items-center">
            <Box
              className="box-border courser-pointer flex mr-16"
              onClick={handleMenuOpen}
            >
              <CustomTypography
                className="pr-6"
                id="date-time"
                color="textDisabled"
                variant="body2"
              >
                {fontSize.charAt(0).toUpperCase() + fontSize.slice(1)}
              </CustomTypography>
              <ArrowUp />
            </Box>
            <Box className="box-border bb-width flex">
              <Box className="pr-8">
                <CustomTypography
                  id="date-time"
                  color="textPrimary"
                  variant="body2"
                >
                  <CurrentDate />
                </CustomTypography>
              </Box>
              <Box>
                <CustomTypography
                  id="date-time"
                  color="textPrimary"
                  variant="body2"
                >
                  <CurrentTime />
                </CustomTypography>
              </Box>
            </Box>
            <Box className="pl-16">
              <CustomAvatar
                id="user-avatar"
                alt={userName}
                src="/static/images/avatar/2.jpg"
                width={42}
                height={42}
                onClick={handleUserMenuOpen}
              >
                {user?.firstName?.charAt(0)}
                {user?.lastName?.charAt(0)}
              </CustomAvatar>
              <CustomMenu
                id="user-menu"
                anchorEl={anchorUserEl ?? document.body}
                open={Boolean(anchorUserEl)}
                onClose={handleUserMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                className="mt-4"
              >
                <CustomMenuList>
                  <CustomMenuItem>
                    <CustomListItemIcon>{<User />}</CustomListItemIcon>
                    {`${user?.firstName} ${user?.lastName}`}
                  </CustomMenuItem>
                  <CustomDivider />
                  <CustomMenuItem>
                    <CustomListItemIcon>{<Email />}</CustomListItemIcon>
                    {user?.email ?? 'N/A'}
                  </CustomMenuItem>
                  {/* <CustomDivider /> */}
                  {/* <CustomMenuItem>
                    <CustomListItemIcon>{<Phone />}</CustomListItemIcon>
                    {user?.phone ?? 'N/A'}
                  </CustomMenuItem> */}
                  <CustomDivider />
                  <CustomMenuItem
                    onClick={() => {
                      handleOpeartionUserLogout();
                      handleUserMenuClose();
                    }}
                  >
                    <CustomListItemIcon>{<Logout />}</CustomListItemIcon>
                    Logout
                  </CustomMenuItem>
                </CustomMenuList>
              </CustomMenu>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
      <Box>
        <CustomMenu
          id="accessibility-menu"
          anchorEl={anchorEl ?? document.body}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <CustomMenuList>
            <CustomMenuItem
              onClick={() => {
                setFontSize('small');
                handleMenuClose();
              }}
            >
              <CustomTypography id="small-font" variant="h6" className="pr-24">
                Small
              </CustomTypography>
              <CustomListItemIcon>
                {fontSize === 'small' && <CheckIcon />}
              </CustomListItemIcon>
            </CustomMenuItem>
            <CustomDivider />
            <CustomMenuItem
              onClick={() => {
                setFontSize('medium');
                handleMenuClose();
              }}
            >
              <CustomTypography id="medium-font" variant="h5" className="pr-24">
                Medium
              </CustomTypography>
              <CustomListItemIcon>
                {fontSize === 'medium' && <CheckIcon />}
              </CustomListItemIcon>
            </CustomMenuItem>
            <CustomDivider />
            <CustomMenuItem
              onClick={() => {
                setFontSize('large');
                handleMenuClose();
              }}
            >
              <CustomTypography id="large-font" variant="h4" className="pr-24">
                Large
              </CustomTypography>
              <CustomListItemIcon>
                {fontSize === 'large' && <CheckIcon />}
              </CustomListItemIcon>
            </CustomMenuItem>
          </CustomMenuList>
        </CustomMenu>
      </Box>
    </Box>
  );
};
export default Appbar;
